export const COINS_REWARD_VALUE = 100
